import {React, useEffect, useState} from "react";
import "../../../styles/desktop/legendaCaixaDagua.css";
import caixa from "../../../assets/img/CaixaDagua.png";

const LegendaCaixadagua = ({ alarmesStatus }) => {
    const [caixaDagua01, setCaixaDagua01] = useState({
        alto: false,
        normal: true,
        baixo: false,
    });

    const [caixaDagua02, setCaixaDagua02] = useState({
        alto: false,
        normal: true,
        baixo: false,
    });

    const [caixaDagua03, setCaixaDagua03] = useState({
        alto: false,
        normal: true,
        baixo: false,
    });

    useEffect(() => {
        const updateCaixaDaguaState = (idxBaixo, idxAlto, setState) => {
            const baixoStatus = alarmesStatus.find((item) => item.idx === idxBaixo)?.state;
            const altoStatus = alarmesStatus.find((item) => item.idx === idxAlto)?.state;
    
            if (baixoStatus) {
                setState({ alto: false, normal: false, baixo: true });
            } else if (altoStatus) {
                setState({ alto: true, normal: false, baixo: false });
            } else {
                setState({ alto: false, normal: true, baixo: false });
            }
        };
    
        if (alarmesStatus.length > 0) {
            // Caixa D'água Entrada
            updateCaixaDaguaState(1, 5, setCaixaDagua01);
    
            // Caixa D'água San Marino
            updateCaixaDaguaState(2, 6, setCaixaDagua02);
    
            // Caixa D'água Positano
            updateCaixaDaguaState(3, 7, setCaixaDagua03);
        }
    }, [alarmesStatus]);
    

    return (
        <>
        <h1 className="tituloCaixa">Nível Caixa D'água</h1>
        <div className="CampoCaixaDagua">

            <div className="caixaDagua01">
                <img src={caixa} alt="CaixaDagua" className="imageCaixa" style={{top: "2%", left: "7.3%"}}/>
                <p className="textoCaixa" style={{top: "24.5%", left: "9.5%",  width: "24.5%", height: "21.5%",backgroundColor: caixaDagua01.alto ? "red" : "transparent" , clipPath: "polygon(0% 0%, 100% 0%, 96.6% 100%, 3% 100%)"}}>Extravazão</p>
                <p className="textoCaixa" style={{ top: "43%", left: "10.15%", width: "23.1%", height: "24%",backgroundColor: caixaDagua01.normal ? "green" : "transparent", clipPath: "polygon(0% 0%, 100% 0%, 95.8% 100%, 4.7% 100%)"}}>Normal</p>
                <p className="textoCaixa" style={{top: "63%", left: "11.2%",  width: "21.1%", height: "24%",backgroundColor: caixaDagua01.baixo ? "red" : "transparent", clipPath: "polygon(0% 0%, 100% 0%, 96.3% 100%, 4.7% 100%)"}}>Baixissímo</p>
                <h2 className="nomeCaixas" style={{top: "90%", left: "9.5%"}}>Caixa D'água Entrada</h2>
            </div>
            <div className="caixaDagua02">
                <img src={caixa} alt="CaixaDagua" className="imageCaixa"style={{top: "2%", left: "35.3%"}}/>
                <p className="textoCaixa" style={{top: "24.5%", left: "37.5%",  width: "24.5%", height: "21.5%",backgroundColor: caixaDagua02.alto ? "red" : "transparent", clipPath: "polygon(0% 0%, 100% 0%, 96.6% 100%, 3% 100%)"}}>Extravazão</p>
                <p className="textoCaixa" style={{ top: "43%", left: "38.15%", width: "23.1%", height: "24%",backgroundColor: caixaDagua02.normal ? "green" : "transparent", clipPath: "polygon(0% 0%, 100% 0%, 95.8% 100%, 4.7% 100%)"}}>Normal</p>
                <p className="textoCaixa" style={{top: "63%", left: "39.2%",  width: "21.1%", height: "24%",backgroundColor: caixaDagua02.baixo ? "red" : "transparent", clipPath: "polygon(0% 0%, 100% 0%, 96.3% 100%, 4.7% 100%)"}}>Baixissímo</p>
                <h2 className="nomeCaixas" style={{top: "90%", left: "37.5%"}}>Caixa D'água San Marino</h2>
            </div>
            <div className="caixaDagua03">
                <img src={caixa} alt="CaixaDagua" className="imageCaixa"style={{top: "2%", left: "63.3%"}}/>
                <p className="textoCaixa" style={{top: "24.5%", left: "65.5%",  width: "24.5%", height: "21.5%",backgroundColor: caixaDagua03.alto ? "red" : "transparent", clipPath: "polygon(0% 0%, 100% 0%, 96% 100%, 4% 100%)"}}>Extravazão</p>
                <p className="textoCaixa" style={{ top: "43%", left: "66.15%", width: "23.1%", height: "24%",backgroundColor: caixaDagua03.normal ? "green" : "transparent", clipPath: "polygon(0% 0%, 100% 0%, 95.8% 100%, 4.7% 100%)"}}>Normal</p>
                <p className="textoCaixa" style={{top: "63%", left: "67.2%",  width: "21.1%", height: "24%",backgroundColor: caixaDagua03.baixo ? "red" : "transparent", clipPath: "polygon(0% 0%, 100% 0%, 96.3% 100%, 4.7% 100%)"}}>Baixissímo</p>
                <h2 className="nomeCaixas" style={{top: "90%", left: "65%"}}>Caixa D'água Positano</h2>
            </div>
        </div>
        </>
    );
};

export default LegendaCaixadagua;